<script>
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Stores
	import BetCashoutReviewStore from '@/Stores/BetCashoutReviewStore.js';

	export let bet;

	let loadingCashout = false;

	const acceptBetCashout = () => {
		loadingCashout = true;
		bet
			.approveCashout()
			.then(() => {
				notify({
					type: 'success',
					title: 'Bet cashout approved',
					message: 'Successfully approved bet cashout',
					timeout: 3
				});
				BetCashoutReviewStore.getBets();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to approve bet cashout',
					timeout: 5
				});
			})
			.finally(() => {
				loadingCashout = false;
			});
	};

	const rejectBetCashout = () => {
		loadingCashout = true;
		bet
			.rejectCashout()
			.then(() => {
				notify({
					type: 'success',
					title: 'Bet cashout rejected',
					message: 'Successfully rejected bet cashout',
					timeout: 3
				});
				BetCashoutReviewStore.getBets();
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to reject bet cashout',
					timeout: 5
				});
			})
			.finally(() => {
				loadingCashout = false;
			});
	};
</script>

<div class="flex flex-row items-center justify-center space-x-6">
	<LoadingButton loading={loadingCashout} className="m-1 btn btn-primary px-4 py-2.5" on:click={acceptBetCashout}
		>Accept</LoadingButton
	>
	<LoadingButton loading={loadingCashout} className="m-1 btn btn-danger px-4 py-2.5" on:click={rejectBetCashout}
		>Reject</LoadingButton
	>
</div>
